import { cn } from "@/lib/utils";

const statusConfig: Record<string, { label: string; className: string }> = {
  CONFIRMADO: { label: "Confirmado", className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20" },
  AGUARDANDO: { label: "Aguardando", className: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/20" },
  CANCELADO: { label: "Cancelado", className: "bg-destructive/10 text-destructive border-destructive/20" },
  CONCLUÍDO: { label: "Concluído", className: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20" },
  SOLICITADO: { label: "Solicitado", className: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/20" },
  REALIZADO: { label: "Realizado", className: "bg-primary/10 text-primary border-primary/20" },
  ANALISADO: { label: "Analisado", className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20" },
  ANEXADO: { label: "Anexado", className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20" },
  ONLINE: { label: "Online", className: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20" },
  PRESENCIAL: { label: "Presencial", className: "bg-muted text-muted-foreground border-border" },
  EXAME: { label: "Exame", className: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20" },
  RECEITA: { label: "Receita", className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20" },
  DOCUMENTO_PESSOAL: { label: "Doc. Pessoal", className: "bg-primary/10 text-primary border-primary/20" },
  RELATÓRIO: { label: "Relatório", className: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/20" },
};

interface StatusBadgePacienteProps {
  status: string;
  className?: string;
}

export function StatusBadgePaciente({ status, className }: StatusBadgePacienteProps) {
  const config = statusConfig[status] || {
    label: status,
    className: "bg-muted text-muted-foreground border-border",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border",
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
}
